import { useCallback, useEffect, useRef, useState } from "react";
import { API } from "../lib/api";
import { readLyricStream } from "../lib/lyricStream";
import { reportError } from "../lib/reportError";

export const useLyricGeneration = () => {
  const [lyrics, setLyrics] = useState("");
  const [generating, setGenerating] = useState(false);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");
  const [generatedModel, setGeneratedModel] = useState("");
  const controllerRef = useRef(null);
  useEffect(() => () => controllerRef.current?.abort(), []);

  const generate = useCallback(async (orderId, model, notes = "") => {
    if (!orderId || controllerRef.current) return;
    const controller = new AbortController();
    controllerRef.current = controller;
    setGenerating(true);
    setReady(false);
    setError("");
    setLyrics("");
    setGeneratedModel("");
    try {
      const response = await fetch(`${API}/orders/${orderId}/lyrics`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model, revision_notes: notes }), signal: controller.signal,
      });
      const result = await readLyricStream(response, setLyrics);
      if (controller.signal.aborted) return;
      setGeneratedModel(result.model);
      setReady(true);
    } catch (error) {
      if (controller.signal.aborted) return;
      reportError("Lyric generation failed", error);
      setError("Lyric generation failed — please try again.");
    } finally {
      if (!controller.signal.aborted) setGenerating(false);
      // Cancel unread data after a malformed or failed stream, not just on unmount.
      controller.abort();
      controllerRef.current = null;
    }
  }, []);
  return { lyrics, generating, ready, error, generatedModel, generate };
};